import { t } from '@lingui/core/macro';
import { BookingStates } from '@/features/booking/enums';

export const bookingStateKeys = () => {
  return {
    [BookingStates.APPROVED]: t({ id: 'bookings.states.approved', message: 'Approved' }),
    [BookingStates.DECLINED]: t({ id: 'bookings.states.declined', message: 'Declined' }),
    [BookingStates.ABORTED]: t({ id: 'bookings.states.aborted', message: 'Aborted' }),
    [BookingStates.EXPIRED]: t({ id: 'bookings.states.expired', message: 'Expired' }),
    [BookingStates.DELIVERED]: t({ id: 'bookings.states.delivered', message: 'Delivered' }),
    [BookingStates.BOOKED]: t({ id: 'bookings.states.booked', message: 'Pending' }),
    [BookingStates.SUCCESSFUL]: t({ id: 'bookings.states.successful', message: 'Successful' }),
    [BookingStates.CANCELED]: t({ id: 'bookings.states.canceled', message: 'Canceled' }),
  };
};
